module.exports = __webpack_public_path__ + "img/image06.14ba379a.jpg";